import Banner from "./components/Banner";
import Notification from "./components/Notification";
import Users from "./components/Users";
// import Access from "./components/Access";
import Download from "./components/Download";

const ProfileOverview = () => {
  return (
    <div className="flex w-full flex-col gap-5">

      <div className="w-ful mt-3 flex h-fit flex-col gap-5 lg:grid lg:grid-cols-12">

        <div className="col-span-full lg:!mb-0">
          <Banner />
        </div>

        {/* <div className="col-span-8 lg:!mb-0">
          <Access />
        </div> */}

      </div>

      <div className="grid h-full grid-cols-1 gap-5 lg:!grid-cols-12">

        <div className="col-span-5 lg:col-span-6 lg:mb-0 2xl:col-span-4">
          <Users />
        </div>
       
        <div className="col-span-5 lg:col-span-6 lg:mb-0 2xl:col-span-4">
          <Notification />
        </div>

        <div className="col-span-5 lg:col-span-6 lg:mb-0 2xl:col-span-4">
          <Download />
        </div>

      </div>
    </div>
  );
};

export default ProfileOverview;
